import {gql} from "graphql-tag";

export const baseField = `
  id
  uniqueId
`;

export const responseField = `
  id
  status
  code
  message
`;

export const basePageableGraphqlField = `
  currentPageNumber
  hasNextPage
  hasPreviousPage
  nextPageNumber
  number
  numberOfPages
  pagesNumberArray
  previousPageNumber
  totalElements
`;


export const GET_COMPLAINT_BADGES_STATS_BY_TYPE = gql `
  query GetComplaintDashboardStats($complaintType: ComplaintApplicationTypeChoices!, $uniqueId: String!) {
    getComplaintDashboardStats(complaintType: $complaintType, uniqueId: $uniqueId) {
      response {
        ${responseField}
      }
      data {
        members
        noticeOfResponse
        informationRequests
        examinations
        mediation
        determination
        complaintAge
        toOverdue
        overdue
        complaintStageAge
        toStageOverdue
        stageOverdue
      }
    }
  }
`;


export const GET_MY_ASSIGNED_COMPLAINT_BADGES_COUNT = gql `
  query GetMyAllComplaintsInboxCount {
    getMyAllComplaintsInboxCount {
      response {
        ${responseField}
      }
      data {
        newComplaints
        reviewComplaints
        revisionComplaints
      }
    }
  }
`;


export const GET_DETERMINATION_COMPLAINT_BADGES_COUNT = gql `
  query GetMyAllDeterminationsInboxCount {
    getMyAllDeterminationsInboxCount {
      response {
        ${responseField}
      }
      data {
        newComplaints
        reviewComplaints
        revisionComplaints
      }
    }
  }
`;
